import angular from 'angular';

export default angular.module('cms.creator.toolbar.sections', [])
  .factory('ToolbarService', function () {

    this.schemas = {};

    /**
     * @param {string} type
     * @param schema {{}, {}}
     */
    let registerSectionSchema = (type, schema) => {
      // Possible validation
      this.schemas[type] = schema;
    };

    let getSectionSchema = (type) => {

      if(!this.schemas[type]) {
        console.error(
          "Config for " + type + " not exists in schema. " +
          "Allowed options: "  + Object.keys(this.schemas).join(", "));
      }
      return this.schemas[type];
    };

    let getSectionDefaultSchema = (type) => {

      let schema = {};
      angular.forEach(this.schemas[type], (value, key) => {
          if(angular.isFunction(value.defaultValue)){
              schema[key] = value.defaultValue(type);
          }
          else {
              schema[key] = value.defaultValue;
          }

      });

      return schema;

    };

    return {
      registerSectionSchema: registerSectionSchema,
      getSectionSchema: getSectionSchema,
      getSectionDefaultSchema: getSectionDefaultSchema
    }

  })
  .name


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Toolbar/ToolbarService.js